// ISO 3166 alpha-2 country code → flag emoji.
//
// Works by mapping each letter to the corresponding Regional Indicator Symbol
// codepoint (A=🇦, B=🇧, …). The pair of regional-indicator letters renders
// as a flag glyph on every modern OS — except Windows pre-22H2, which shows
// the two-letter code instead (acceptable fallback).
//
// Returns the empty string if `iso` is not a valid 2-letter ASCII code.

export function flagFromIso(iso: string): string {
  const up = iso.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(up)) return '';
  const A = 'A'.charCodeAt(0);
  const offset = 0x1f1e6 - A; // 🇦 = U+1F1E6
  return (
    String.fromCodePoint(up.charCodeAt(0) + offset) +
    String.fromCodePoint(up.charCodeAt(1) + offset)
  );
}
